
import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from './Components/Home';
import NewProject from "./Components/NewProject";
import UpdateCode from './Components/UpdateCode';



function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);

  return (
    <div className="w-screen h-screen flex items-start justify-start overflow-hidden">
      <BrowserRouter>
        <Routes>
          {/* Route for the Home component */}
          <Route path="/home/*" element={<Home setIsLoggedIn={setIsLoggedIn} user={user} setUser={setUser} />} />

          {/* Route for the NewProject component */}
          {isLoggedIn ? (
            <>
              <Route path="/newpro" element={<NewProject setIsLoggedIn={setIsLoggedIn} setUser={setUser} user={user} />} />

              <Route path="/updatecode/:projectId" element={<UpdateCode setIsLoggedIn={setIsLoggedIn} setUser={setUser} user={user}/>} />
            </>

          ) : (
            // Redirect to Home if not logged in
            <>
            <Route path="/newpro" element={<Navigate to="/home/login" />} />
            <Route path="/updatecode" element={<Navigate to="/home/projects/login" />} />
            </>
          )}

         {/* <Route path="*" element={<Navigate to={"/home"} />} />*/}
        
        <Route path="*" element={<Navigate to={"/home/projects/"} />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;